// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-ps-min-width{min-width:150px}li:focus,.bw-bw-icon:focus{outline-color:#0c0243;outline-offset:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ps-min-width": "bw-ps-min-width",
	"bw-icon": "bw-bw-icon"
};
module.exports = ___CSS_LOADER_EXPORT___;
